import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-120dc3de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "GlobalHeader" }
const _hoisted_2 = { class: "GlobalHeader_Container" }
const _hoisted_3 = { class: "GlobalHeader_Wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "GlobalHeader_Title"
}
const _hoisted_5 = {
  key: 1,
  class: "GlobalHeader_Title"
}
const _hoisted_6 = { class: "GlobalHeader_Wrapper" }

import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  emits: ["toggleSideBar"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const $router = useRouter();
const emit = __emit;

let toggleSideBar = () => {
  emit("toggleSideBar");
};
const logout = () => {
  store.dispatch("login/logout");
  $router.push("/");
};

// 講談社用表示制御
const storeUserData = computed(() => {
  return store.getters["login/getUserData"];
});
const isKodansha = computed(() => {
  return storeUserData.value.hanmotoCd == "2253";
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleSideBar) && _unref(toggleSideBar)(...args))),
          class: "ToggleSideBar"
        }, [
          _createVNode(_component_font_awesome_icon, {
            class: "ToggleSideBar_Icon",
            icon: "bars"
          })
        ]),
        (isKodansha.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "KPS台割システム（仮称）"))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, "受注こねくと"))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", null, "ようこそ " + _toDisplayString(_unref(store).getters["login/getLoginSyotenName"]) + "様", 1),
        _createElementVNode("a", null, [
          _createVNode(_component_router_link, { to: "/userInfo" }, {
            default: _withCtx(() => [
              _createTextVNode("ユーザー情報")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("a", null, [
          (_unref(store).getters['login/getLoginSyotenRole'] === 'ADMIN')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/admin"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("管理者")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("a", { onClick: logout }, "ログアウト")
      ])
    ])
  ]))
}
}

})